export default __webpack_public_path__ + "static/media/33_3_0.0a870707.png";